import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

interface Breadcrumb {
  label: string
  path: string | number
  isActive?: boolean
}

interface BreadcrumbsComponentProps {
  breadcrumbs: Breadcrumb[]
}

const BreadcrumbsComponent: React.FC<BreadcrumbsComponentProps> = ({
  breadcrumbs,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const handleNavigation = (path: string | number) => {
    if (typeof path === 'number') {
      navigate(path)
    } else {
      navigate(path)
    }
  }

  return (
    <div className="grid grid-cols-1 gap-4">
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {breadcrumbs.map((breadcrumb, index) => {
          const isActive = location.pathname === breadcrumb.path
          return isActive || breadcrumb.isActive ? (
            <Typography
              key={index}
              className="text-gray-500 text-sm cursor-pointer  no-underline"
            >
              <span>{breadcrumb.label}</span>
            </Typography>
          ) : (
            <Link
              key={index}
              sx={{ textDecoration: 'none' }}
              onClick={() => handleNavigation(breadcrumb.path)}
              className="text-primary-500  text-sm cursor-pointer
               no-underline"
            >
              <b>{breadcrumb.label}</b>
            </Link>
          )
        })}
      </Breadcrumbs>
    </div>
  )
}

export default BreadcrumbsComponent
